import { OrganizationInterface } from "../interfaces/Organizations.interface";
import { OrgType } from "../flatbuffers/generated/archive/org-type";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_ORGANIZATION: OrganizationInterface = {
  id: null,
  address: "",
  type: OrgType.ORG,
  city: "",
  country: "",
  name: "",
  phoneCode: "+1",
  phone: "",
  state: "",
  parentId: null,
};
